module.exports = __webpack_public_path__ + "img/RE.8ce87b04.png";